// src/components/auth/CodeInput.jsx
// Six digit boxes for the SMS code. No placeholder digits. One real (but
// invisible) input drives all six, so typing, backspace, and pasting the
// whole code just work — and iOS offers the code straight from the text
// message (autoComplete="one-time-code"). The active box is highlighted.
import { useRef } from "react";

export default function CodeInput({ value = "", onChange, onSubmit }) {
  const val = String(value).replace(/\D/g, "").slice(0, 6);
  const inputRef = useRef(null);

  return (
    <div
      className="relative mb-4 cursor-text"
      onClick={() => inputRef.current && inputRef.current.focus()}
    >
      <input
        ref={inputRef}
        value={val}
        onChange={(e) =>
          onChange(e.target.value.replace(/\D/g, "").slice(0, 6))
        }
        onKeyDown={(e) => {
          if (e.key === "Enter" && onSubmit) onSubmit();
        }}
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus
        aria-label="6 digit code"
        className="absolute inset-0 w-full h-full opacity-0"
      />
      <div className="flex gap-2 pointer-events-none">
        {Array.from({ length: 6 }, (_, i) => (
          <div
            key={i}
            className={`flex-1 h-14 rounded-lg border-2 bg-white flex items-center justify-center text-2xl font-bold text-slate-900 ${
              i === Math.min(val.length, 5) && val.length < 6
                ? "border-slate-800"
                : val[i]
                  ? "border-slate-400"
                  : "border-slate-300"
            }`}
          >
            {val[i] || ""}
          </div>
        ))}
      </div>
    </div>
  );
}
